module.exports = "/api/cdn/public/static-assets/images/e740c51bb099110dff2900fa4fc94d72.png";